<table [class]="this.className" [ngStyle]="{'width': this.isWidthComplete ? '100%' : '50%'}">
  <tr *ngIf=" this.isIncludeTableHeader === true ">
    <th *ngIf="this.tourLengthShortName!=''" colspan='5' class='boxin' scope='col'><img class="mr-2"
        src="assets/images/search-pages/icons/itinerary.png" width="25" height="25">{{ this.daysItinerary }} {{
      this.tourLengthShortName }}-Day Cruise aboard the {{ this.cruiseName }}</th>
    <th *ngIf="this.tourLengthShortName ==''" colspan='5' class='boxin' scope='col'><img class="mr-2"
        src="assets/images/search-pages/icons/itinerary.png" width="25" height="25"> {{ this.cruiseName }}</th>
  </tr>
  <tbody *ngFor="let iter of itineraries; let i = index" [ngStyle]="{ 'background': !isPair(i) ? 'white' : '#f5f5f5' }">
    <tr *ngFor="let activity of getAllActivities(iter); let j = index">
      <td *ngIf="j === 0" [rowSpan]="getAllActivities(iter).length" class="iti-day"
        [ngClass]="{ 'small-font': isfontSmall }" style="font-size: 12px;">
        <span>{{ iter.diaSemana.substring(0, 3).toUpperCase() }}</span>
      </td>
      <td *ngIf="j === 0 || activity.isMorning !== getAllActivities(iter)[j-1]?.isMorning"
        [rowSpan]="activity.isMorning ? iter.morningActivities.length : iter.afternoonActivities.length" class="iti-day"
        [ngClass]="{'small-font': isfontSmall,'am-pm-iti': activity.period === 'A.M.' || activity.period === 'P.M.'}">
        {{ activity.period }}
      </td>
      <td
        [ngClass]="{'small-font': isfontSmall,'activity-am-iti': activity.period === 'A.M.','activity-pm-iti': activity.period === 'P.M.'}">
        <strong>
          <span *ngIf="activity.optional">or </span>{{ activity.isla }}
        </strong>
        <span *ngIf="activity.nombre">
          <span *ngIf="activity.isla">:</span> {{ activity.nombre }}
        </span>
      </td>
    </tr>
  </tbody>
</table>
<div *ngIf="this.itineraryDescription!=''" class="text-justify" style="padding: 10px 0;"
  [innerHtml]="addStyleToDescription(this.itineraryDescription)">
</div>